import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || "https://server229256.nazwa.pl"
).replace(/\/$/, "");

const DemoAutoLogin = () => {
  const navigate = useNavigate();
  const startedRef = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    const startDemo = async () => {
      try {
        localStorage.removeItem("token");
        localStorage.removeItem("user");

        const { data } = await axios.post(
          `${API_BASE_URL}/demo-login`,
          {},
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          }
        );

        if (!data?.token || !data?.user) {
          throw new Error("Invalid demo login response");
        }

        localStorage.setItem("token", data.token);
        localStorage.setItem("user", JSON.stringify(data.user));
        navigate("/sprzedaz/dashboard", { replace: true });
      } catch (requestError) {
        console.error("Demo auto-login error:", requestError);
        setError(
          requestError?.response?.data?.message ||
            "Nie udało się uruchomić wersji demo. Spróbuj ponownie później."
        );
      }
    };

    startDemo();
  }, [navigate]);

  return (
    <Page>
      <Card>
        {!error ? (
          <>
            <Spinner aria-hidden="true" />
            <h1>Uruchamiamy wersję demo…</h1>
            <p>Za chwilę nastąpi automatyczne przekierowanie.</p>
          </>
        ) : (
          <>
            <h1>Demo jest chwilowo niedostępne</h1>
            <p>{error}</p>
            <Button type="button" onClick={() => window.location.reload()}>
              Spróbuj ponownie
            </Button>
          </>
        )}
      </Card>
    </Page>
  );
};

const Page = styled.main`
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 24px;
  background: linear-gradient(135deg, #effcfd, #ffffff);
  font-family: "Chivo", sans-serif;
`;

const Card = styled.section`
  width: min(520px, 100%);
  padding: 42px 32px;
  text-align: center;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(17, 94, 99, 0.14);

  h1 {
    margin: 18px 0 10px;
    color: #1f2937;
  }

  p {
    color: #64748b;
    line-height: 1.6;
  }
`;

const Spinner = styled.div`
  width: 52px;
  height: 52px;
  margin: 0 auto;
  border: 5px solid #d8f5f7;
  border-top-color: #3bc3cc;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const Button = styled.button`
  margin-top: 12px;
  padding: 12px 22px;
  border: 0;
  border-radius: 999px;
  background: #3bc3cc;
  color: #ffffff;
  font-weight: 700;
  cursor: pointer;
`;

export default DemoAutoLogin;
